import React, {useContext} from "react";
import {AuthContext} from "../../providers/AuthProvider";
import {Statut} from "../types/Types";

interface BYStatusButtonGroupProps {
    title?: string;
    disabled?: boolean;
    onChange: (arg0: number) => void;
    value?: number;
    required?: boolean;
}

const BYStatusButtonGroup = (props: BYStatusButtonGroupProps) => {
    const {title, disabled, onChange, value} = props;
    const {status} = useContext(AuthContext);

    return <>
        {title && <label className="form-label">{title}</label>}
        <div>
            <div className={`btn-group`} role="group" aria-label="Basic example">
                {status.map(status => {
                    let className = '';

                    if (status.refStatut === 1) {
                        className = 'btn-outline-secondary';
                    } else if (status.refStatut === 2) {
                        className = 'btn-outline-success';
                    } else {
                        className = 'btn-outline-info';
                    }

                    if (status.refStatut === value) {
                        className = className.replace('outline-', '');
                    }

                    return <button
                        key={`btn-status-${status.refStatut}`}
                        type="button"
                        className={`btn ${className}`}
                        disabled={disabled}
                        onClick={() => {
                            onChange(status.refStatut);
                        }}
                    >
                        {status.libStatut}
                    </button>;
                })}
            </div>
        </div>
    </>
};

export default BYStatusButtonGroup;

interface BYStatusBadgeProps {
    statusId: number;
    statusText: string;
}

export const BYStatusBadge = ({statusId, statusText}: BYStatusBadgeProps) => {
    let className;

    if (statusId === 1) {
        className = 'bg-secondary';
    } else if (statusId === 2) {
        className = 'bg-success';
    } else {
        className = 'bg-info';
    }

    return <span className={`badge text-light ${className}`}>{statusText}</span>;
};


interface BYStatusButtonProps {
    status: Statut;
    onClick: () => void;
    disabled?: boolean;
}

export const BYStatusButton = ({status, onClick, disabled = false}: BYStatusButtonProps) => {
    let className;

    if (status.refStatut === 1) {
        className = 'btn-secondary';
    } else if (status.refStatut === 2) {
        className = 'btn-primary';
    } else {
        className = 'btn-info';
    }

    return <button type="button" className={`btn ${className}`} onClick={onClick} disabled={disabled}>
        {status.libStatut}
    </button>;
};
